import { useCallback } from "react";
import { useAuthQuery } from "./useAuthQuery";

export const useGetAgentInfo = () => {
  const select = useCallback((data) => {
    return data?.data?.data;
  }, []);

  const response = useAuthQuery(
    {
      method: "POST",
      url: "/info",
    },
    { queryKey: ["getInfo"], select, refetchOnWindowFocus: false }
  );

  return response;
};
